import * as React from 'react';
import {Link, LinkProps} from '@sail/ui';
import {ExternalUrl} from '@sail/navigation';
import {styles} from 'mkt-ssr/components/sail/Markdown/components/LinkWithTransformations/LinkWithTransformationsStyles';
import {useAnalytics} from 'mkt-ssr/lib/analytics';
import {useLinkResolver} from 'mkt-ssr/lib/routing/LinkResolver';
import {ProtocolLink} from '@stripe-internal/mkt-ssr-models';

type Props = Omit<LinkProps, 'href'> & {href: ExternalUrl | ProtocolLink};

/**
 * Markdown Link component. This attempts to run the link URL through
 * an optionally provided transformer function from the context, if present.
 * This allows applications to apply logic for URL manipulation that
 * they otherwise cannot in Markdown because they do not have direct access
 * to the rendering tree.
 */
export function LinkWithTransformations({href, ...rest}: Props) {
  const {link} = useAnalytics();
  const {createRoute} = useLinkResolver();

  const handleOnPress = () => {
    link('Clicked', {
      category: 'Links',
      label: 'Related content',
    });
  };

  return (
    <Link
      href={createRoute(href)}
      onPress={handleOnPress}
      {...rest}
      uses={[styles.link]}
    />
  );
}
